<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          List of Curated Products & Services
        </h2>

        <small class="text-muted">Manage all your services here. </small>
      </div>
      <base-button
        type="primary"
        class="px-6 py-1 mx-1 flex items-center"
        @click="handleAdd"
      >
        <feather-icon
          icon="PlusIcon"
          svgClasses="w-5 font-semibold text-white cursor-pointer"
          class="mr-1"
        ></feather-icon>
        Create Content
      </base-button>
    </div>
    <BlogOffersTable />
  </b-card>
</template>

<script>
import BlogOffersTable from "./components/BlogOffersTable.vue";

export default {
  components: {
    BlogOffersTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addoffersblogcontent" });
    },
  },
};
</script>
